import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card-header",
  id: "kt_chat_messenger_header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DesignerTitle = _resolveComponent("DesignerTitle")!
  const _component_DesignerToolbar = _resolveComponent("DesignerToolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DesignerTitle, { formSection: _ctx.formSection }, null, 8, ["formSection"]),
    (!_ctx.isPreview)
      ? (_openBlock(), _createBlock(_component_DesignerToolbar, {
          key: 0,
          isPreview: _ctx.isPreview,
          onSaveData: _ctx.emitSaveData,
          designCreated: _ctx.designCreated,
          onCreateTable: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('create-table'))),
          formSection: _ctx.formSection,
          isTemplate: _ctx.isTemplate,
          disabled: _ctx.disabled,
          onGetPreviewData: _ctx.getPreviewData,
          loading: _ctx.loading,
          onConfirmDiscard: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm-discard'))),
          onToggleIsTemplate: _ctx.toggleIsTemplate
        }, null, 8, ["isPreview", "onSaveData", "designCreated", "formSection", "isTemplate", "disabled", "onGetPreviewData", "loading", "onToggleIsTemplate"]))
      : _createCommentVNode("", true)
  ]))
}